import type {TFunction} from "i18next";
import {format, isThisWeek, isToday} from "date-fns";
import type {Locale} from "date-fns/locale";
import type {PublicNewsArticleV2} from "../../dibAdminApi/dibAdminApi";

export type NewsGroup = {label: string; items: PublicNewsArticleV2[]};

/**
 * Buckets news articles (already newest-first) into the design's date
 * sections: "Today – {date}", "This week", "Previously" (which also catches
 * items without a pubDate). Empty buckets are omitted.
 */
export function groupNewsByDate(
    items: PublicNewsArticleV2[],
    t: TFunction,
    locale: Locale
): NewsGroup[] {
    const today: PublicNewsArticleV2[] = [];
    const thisWeek: PublicNewsArticleV2[] = [];
    const previous: PublicNewsArticleV2[] = [];

    for (const item of items) {
        const date = item.pubDate ? new Date(item.pubDate) : null;
        if (date && isToday(date)) {
            today.push(item);
        } else if (date && isThisWeek(date, {weekStartsOn: 1})) {
            thisWeek.push(item);
        } else {
            previous.push(item);
        }
    }

    const groups: NewsGroup[] = [];
    if (today.length > 0)
        groups.push({
            label: `${t("date.today")} – ${format(new Date(), "d. MMMM yyyy", {locale})}`,
            items: today,
        });
    if (thisWeek.length > 0)
        groups.push({
            label: t("date.thisWeek", {defaultValue: "This week"}),
            items: thisWeek,
        });
    if (previous.length > 0)
        groups.push({label: t("date.previously"), items: previous});
    return groups;
}
